<template>
  <div class="input">
    <input type="text" v-model="searchData" :placeholder="placehoder">
    <!-- <Icon class='icon' type="ios-search" @click="getSearch"/> -->
    <i class="searchIcon" @click="getSearch"></i>
  </div>
</template>

<script>
export default {

  data () {
    return {

    };
  },
  props: ['placehoder', 'searchData'],
  methods: {
    getSearch: function () {
      this.$emit('search', this.searchData)
    }
  }

};
</script>

<style scoped rel="stylesheet/less" lang="less">
  @import url("../../assets/theme/themeBlue.less");

  .input {
    width: 200px;
    height: 30px;
    position: relative;
  }

  .input input {
    float: left;
    font-size: 14px;
    border: 1px solid @primary;
    border-radius: 3px;
    outline: none;
    height: 100%;
    line-height: 100%;
    width: 100%;
    padding: 0 25px 0 8px;
    // color: #AFAFAF;

    &::placeholder {
      color: #AFAFAF;
    }
  }

  .input.radius input {
    border-radius: 15px;
  }

  .input input:focus {
    border: 1px solid @primary-hover;
  }

  // .input .icon{
  //    position: absolute;
  //    right: 5px;
  //    top: 7px;
  //    cursor: pointer;
  // }
  .input .searchIcon {
    display: inline-block;
    width: 18px;
    height: 19px;
    background: url(../../assets/images/default/search.png) no-repeat center center;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
</style>
